export const EmployeeContractEN = {
  "EmployeeContractAdd": {
    "EmployeeContractAdd": "Add CurrentEmployee Contract ",
    "EmployeeContractEdit": "Edit CurrentEmployee Contract  ",
    "EmployeeContractDelete": "Delete CurrentEmployee Contract",
    "ListEmployeeContract": "List CurrentEmployee Contract",
    "LiquidationEmployeeContract" : "Liquidation CurrentEmployee Contract ",
    "ApprovalEmployeeContract" : "Approval CurrentEmployee Contract",
    "QuickView" : "Quick content",
    "undoApproval" : "Undo approval "
  },
  "EmployeeContractTitle": {
    "employeeContractId": "Contract Code",
    "fullName": "Staff's name",
    "CurrentDepartment": "Department ",
    "signDay": "Sign day",
    "effectiveDate": "Effective from the date",
    "tillDate": "To date ",
    "Status": "Status ",
    "StatusQuo" : "Status",
    "creator": "Creator " ,
    "creatdate" : "Date created ",
    "employeeId" : "Employee" ,
    "contractId" : "Contract",
    "form" : "Employment Type" ,
    "position" : "Job Position" ,
    "office" : "Job Title",
    "workplace" : "Work location",
    "signerId" : "Signer",
    "FIle" : "Attrack file",
    "glone" : "Pay grade",
    "to" : " To ",
    "description" : "Note",
    "informationSalary" : "Salary and allowances information",
    "informationGeneral" : "General information",
    "notFound" : "No salary and allowance information",
    "approved" : "Approved",
    "liquidated" : "Liquidation",
    "pending" : "Pending",
    "end" : "End",
    "Unsigned" : "Unsigned",
    "ineffect" :  "In Effect",
    "expired" :  "Expired",
    "notyetvalid" : "Not Yet Valid",
    "status" : "Status",
    "contractName" : "Contract name",
    "jobDetails" : "Job details",
    "Working": "Working",
    "Waiting" : "Waiting",
    "DropTemp" : "DropTemp",
    "Resignation" : "Resignation"
  },
  "placeholderEMC": {
    "employeeContractId": "Contract Code",
    "fullName": "Staff's name",
    "CurrentDepartment": "Department ",
    "signDay": "Sign day",
    "effectiveDate": "Effective from the date",
    "tillDate": "To date ",
    "Status": "Status ",
    "creator": "Creator " ,
    "creatdate" : "Date created ",
    "employeeId" : "Search code , fullname..." ,
    "contractId" : "Contract",
    "form" : "Format" ,
    "position" : "Job Position" ,
    "office" : "Job Title",
    "workplace" : "Work location",
    "signerId" : "Signer",
    "FIle" : "Attrack file",
    "signerDay" : "Sing Day",
    "glone" : "Pay grade",
    "since" : "Since",
    "Note" : "Note",
    "Salaryform" : "Salary form ",
    "Amountofmoney" : "Amount of money",
    "Allowance" : "Allowance"
	},
  "buttonEMC" : {
    "buttonSubmit" : "Create",
    "buttonUpdate" : "Update",
    "buttonCancel" : "Cancel",
    "buttonKeep" : "Keep the page after",
    "buttonGo" : "Go to the list after",
    "approve" : "Approve",
    "agree" : "Agree"
  },
  "NotificationEmployeeContract": {
    "edit": "Edit data successfully...",
    "add": "Add data successfully...",
    "delete": "Delete data successfully...",
    "Liquidation": "Status update successful...",
    "question" : " Do you want to delete ? ",
    "questionApproval" : "Do you want to approve this employee contract? ",
    "approval" : "Approval successful......",
    "titleApproval" : "Approval employee contract",
    "effectiveToSingDay" : "Signing date must not be greater than contract end date",
    "effectiveToSince" : "Salary and allowances from the date of contract must not be greater than the contract termination date",
    "effectiveFromSince" : "Salary and allowances from the date must not be less than the contract start date",
    "effectiveFromEffectiveTo" : "CurrentEmployee Contract expiration date after the effective date",
    "salaryError" : "Salary form of the day ",
    "salaryError1" : " do not overlap ",
    "AllowanceError" : "Type of allowance of the day ",
    "updateSuccess" : "successfully updated...........",
    "startDate" : "Start date ( ",
    "notJoinDate" : " ) must not be less than Working Day",
    "questionUndo" : "Are you sure you want to undo approval? ",
  }
}